export default {
      id: "vk-usage",
      viewBox: "0 0 24 15",
      url: __webpack_public_path__ + "img/icons.svg#vk",
      toString: function () {
        return this.url;
      }
    }